var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gh-list-item__head" }, [
    _c("div", { staticClass: "gh-list-item__head-left" }, [
      _vm.serviceNameKey
        ? _c("span", { staticClass: "gh-list-item__service" }, [
            _vm._v(_vm._s(_vm.$t(_vm.serviceNameKey))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.projectName
        ? _c("span", { staticClass: "gh-list-item__project" }, [
            _vm._v(_vm._s(_vm.projectName)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "gh-list-item__datetime" }, [
      _vm._v(_vm._s(_vm.formattedDatetime)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }